import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  advertisement: [],
  allAdvertisement: [],
  eliteAdvertisement: []
};

export const AdvertisementsSlice = createSlice({
  name: "advertisements",
  initialState,
  reducers: {
    getAdvertisementsAction: (state, action) => {
      
      state.allAdvertisement = action.payload;
    },
    getAdvertisementAction: (state, action) => {
      state.advertisement = action.payload;
    },

    getEliteadsAction: (state, action) => {
      state.eliteAdvertisement = action.payload;
    },
  },
});

export default AdvertisementsSlice.reducer;

export const { getAdvertisementsAction, getAdvertisementAction, getEliteadsAction } = AdvertisementsSlice.actions;
